import { msalInstance, apiTokenRequest } from '../authConfig';

// Shared in-flight promise to prevent concurrent token acquisitions.
// Multiple callers coalesce onto a single MSAL request.
let inFlightToken = null;

function getAccount() {
    return msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0] || null;
}

/**
 * Acquires a valid access token for the backend API (silent only).
 * Never opens a popup — safe for background/timer use.
 * Throws on failure so callers can handle gracefully.
 */
export async function getApiTokenSilent() {
    const account = getAccount();
    if (!account) {
        throw new Error('No authenticated account found');
    }

    const response = await msalInstance.acquireTokenSilent({
        ...apiTokenRequest,
        account,
    });
    return response.accessToken;
}

/**
 * Acquires a valid access token for the backend API.
 * Tries silent acquisition first; falls back to popup if interaction is required.
 * Concurrent callers share a single in-flight request.
 */
export async function getApiToken() {
    if (inFlightToken) {
        return inFlightToken;
    }

    inFlightToken = (async () => {
        const account = getAccount();
        if (!account) {
            throw new Error('No authenticated account found');
        }

        const request = {
            ...apiTokenRequest,
            account,
        };

        try {
            const response = await msalInstance.acquireTokenSilent(request);
            return response.accessToken;
        } catch (error) {
            if (error.name === 'InteractionRequiredAuthError') {
                const response = await msalInstance.acquireTokenPopup(request);
                return response.accessToken;
            }
            throw error;
        }
    })();

    try {
        return await inFlightToken;
    } finally {
        inFlightToken = null;
    }
}
